import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import { useGetUnreadMessageCountQuery } from '../graphql/generated/operations/messages.ts';
import { useAuth } from './auth.context.tsx';

export interface NotificationContextProps {
  unreadMessages: number;
  updateNotificationCount: () => void;
}

const NotificationContext = createContext<NotificationContextProps>({} as NotificationContextProps);

export interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: FC<NotificationProviderProps> = (props) => {
  const [unreadMessages, setUnreadCount] = useState(0);
  const { isLoggedIn } = useAuth();
  const { data, refetch } = useGetUnreadMessageCountQuery({
    skip: !isLoggedIn
  });

  useEffect(() => {
    if (data) {
      setUnreadCount(data.getUnreadCount);
    }
  }, [data]);

  const updateNotificationCount = () => {
    refetch();
  };

  return (
    <NotificationContext.Provider
      value={{
        unreadMessages,
        updateNotificationCount
      }}
      {...props}
    />
  );
};

export const useNotifications = () => useContext(NotificationContext);
